import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {ProcedureStepGroupType} from 'procedures/ProcedureDomainTypes';
import {DefaultStatusDisplayName} from 'processes/ProcessConstants';
import {patchJSONPromise} from 'util/Net';

export interface ReadyStepTransition {
  transitionToStatus: DefaultStatusDisplayName;
  stepGroupType: ProcedureStepGroupType;
}

export interface UpdateProcedureMethodExecutionInstancesParams extends UpdateArchivableParams {
  id: string;
  actionOrigin?: string;
  transition?: {
    comment: string;
    transitionToStatus: DefaultStatusDisplayName;
    timestampUtcIsoformat: string;
    readyStepTaskTransitions?: Array<ReadyStepTransition>;
  };
  sourceExperimentMethodInstanceIds?: Array<string>;
}

export interface UpdateProcedureMethodExecutionInstancesResponse {
  updatedIds: Array<string>;
}

export function updateProcedureMethodExecutionInstances(
  updates: Array<UpdateProcedureMethodExecutionInstancesParams>
): Promise<UpdateProcedureMethodExecutionInstancesResponse> {
  return patchJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE),
    data: {updates},
  });
}
